<template functional>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 517.3 517.3" style="stroke-width:24.81px"><rect class="cls-1" x="751" y="751" width="498" height="498" rx="59.24" transform="translate(1258.65 1258.65) rotate(180)"/><line class="cls-1" x1="507.65" y1="386.31" x2="9.65" y2="386.31"/><rect x="62.57" y="440.72" width="45.22" height="19.28"/><rect x="138.57" y="440.72" width="45.22" height="19.28"/><rect x="214.58" y="440.72" width="45.22" height="19.28"/></svg>
</template>

<script>
export default {
}
</script>
